import React from "react";
import { PlayListItem, AudioPlayer } from "../components";
import { useLocation } from "react-router-dom";
import { Skeleton } from "../components/ui/skeleton";
import { useAudioPlayer } from "../context/AudioPlayerContext";

const PlayList = ({ columns, dayData, title, items = [], loading, onToggleFavorite }) => {
  const location = useLocation();
  const { audioData, isPlaying, playAudio, setAudioData, showPlayer, setShowPlayer } = useAudioPlayer();

  const columnClassMap = {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6",
  };

  const gridColumnsClass = columns && columnClassMap[columns] ? columnClassMap[columns] : "";
  const sidebarClass = `mt-3 grid mb-6 gap-x-6 rounded-xl ${location.pathname === "/single-day" ? "border border-gray-100" : ""} ${gridColumnsClass}`;

  const handleTogglePlay = (src, title, excerpt = "") => {
    if (audioData?.src === src) {
      // If same audio is clicked again, toggle play/pause
      playAudio({ ...audioData, src, title, excerpt, toggle: true });
    } else {
      playAudio({ src, title, excerpt });
    }
    if (typeof setShowPlayer === "function") setShowPlayer(true);
  };

  return (
    <div>
      <h5 className="mb-2 text-base font-bold leading-5 text-gray-900">{title}</h5>
      <ul className={sidebarClass}>
        {loading
          ? Array.from({ length: 4 }).map((_, index) => (
              <li key={index} className="p-4 border-b border-gray-100 last:border-b-0">
                <Skeleton className="w-2/4 h-6 mb-2 rounded-md" />
                <Skeleton className="w-1/6 h-4 rounded-md" />
              </li>
            ))
          : items.map((item, index) => {
              const src = item?.attributes?.ps_latin_long_audio_url;
              return (
                <li key={index} className="border-b border-gray-100 last:border-b-0">
                  <PlayListItem
                    title={item?.attributes?.title}
                    slug={item?.attributes?.slug || "missing slug"}
                    duration=""
                    mediaUrl={src}
                    favorite={item?.attributes?.favorite}
                    onToggleFavorite={() => onToggleFavorite(item.id)}
                    isPlaying={isPlaying}
                    isActive={audioData?.src === src}
                    onPlay={() => handleTogglePlay(src, item?.attributes?.title, dayData?.date || "")}
                    dayData={dayData}
                  />
                </li>
              );
            })}
      </ul>

      {showPlayer && audioData?.src && (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white-50">
          <AudioPlayer
            src={audioData.src}
            title={audioData.title}
            excerpt={audioData.excerpt}
          />
        </div>
      )}
    </div>
  );
};

export default PlayList;
